module.exports = __webpack_public_path__ + "static/img/logo.462fbd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/business/logo.png
// module id = 34u/
// module chunks = 24